export default __webpack_public_path__ + "static/media/sling.fdccf069.png";